import { Children } from 'react';
import { Switch } from 'react-router';
import { useMultiLayerDrawerEnabled } from '../../modules/taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';

export const CustomizedSwitchWrapper = ({ children }) => {
    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();
    const childrenArray = Children.toArray(children);

    if (isMultiLayerDrawerEnabled) {
        return (
            <>
                <Switch>{childrenArray.slice(0, childrenArray.length - 1)}</Switch>
                {childrenArray[childrenArray.length - 1]}
            </>
        );
    }

    return <Switch>{children}</Switch>;
};
